import { Expose } from "class-transformer";
import { DropdownModel } from "./dropdown-model";

export class planLearningObjectives extends DropdownModel {
    @Expose() id: string;
    @Expose() name: string;
    @Expose() type: string;

    override get dropDownDisplayName(): string {
        return this.name;
    }
    override get dropDownValue(): Object {
        return this;
    }
}